// extracted by mini-css-extract-plugin
export default {"image":"contact_image__kFpDD","container":"contact_container__yzpJv","root":"contact_root__TGFIz"};